import styled from 'styled-components';
import { ApButtonMain } from '@alixpartners/ui-components';
import CheckboxGroupUnstyled from 'components/CheckboxGroup';
import { Bar } from 'components/CheckboxGroup/styles';
import { colors } from '@alixpartners/ui-components';

export const StepTitle = styled.div`
	color: ${colors.grey5};
	font-size: 13px;
	line-height: 19px;
	text-align: center;
	letter-spacing: 0.3px;
	padding-bottom: 40px;
`;

export const StepFooter = styled.div`
	padding-top: 17px;
	display: flex;
`;

export const ButtonMain = styled(ApButtonMain)`
	margin-left: auto;
`;

export const CheckboxGroup = styled(CheckboxGroupUnstyled)`
	${Bar} {
		padding: 6px;
		min-height: 28px;
		padding-left: 0;
		margin-left: -1px;
		letter-spacing: 0.3px;
	}
`;
